module.exports = __webpack_public_path__ + "static/images/info-grey.cb246a51b46a0c81a26792b45f1ee460.svg";